import { render, staticRenderFns } from "./producer_submit_select_ciders.vue?vue&type=template&id=5c4cc1e8&scoped=true"
import script from "./producer_submit_select_ciders.vue?vue&type=script&lang=js"
export * from "./producer_submit_select_ciders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4cc1e8",
  null
  
)

export default component.exports